import classNames from 'classnames';
import React from 'react';
import { DropdownContext } from './DropdownContext';
import s from './styles.module.css.json';
export var OptionAction = function (_a) {
    var icon = _a.icon, red = _a.red, onClick = _a.onClick, closeMenuOnClick = _a.closeMenuOnClick;
    return (React.createElement(DropdownContext.Consumer, null, function (context) {
        var _a;
        return (React.createElement("button", { type: "button", className: classNames(s.Dropdown__menu__option__icon, (_a = {},
                _a[s['Dropdown__menu__option__icon--delete']] = red,
                _a)), onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (closeMenuOnClick !== null && closeMenuOnClick !== void 0 ? closeMenuOnClick : true) {
                    context.closeMenu();
                }
                onClick(e);
            } }, icon));
    }));
};
OptionAction.displayName = 'DropdownOptionAction';
//# sourceMappingURL=OptionAction.js.map